import moment from 'moment/moment'
$(document).on("turbolinks:load",function(){
  
  if ($('.aep_start_date').length) {
    let url = $('.aep_start_date').data('url');
    let start_date = new Date($('.aep_start_date').text()); 
    let end_date = new Date($('.aep_end_date').text()); 
    
    download(start_date,end_date,url)
  }
});

function download(date,end_date,url)
{
  var date_text = moment(date).format("yyyy-MM-DD");
  $.ajax({
    type: 'POST',
    url: url,
    data: {
      functions_aep_download: {request_date: date_text},
    },
    dataType: 'script',
    error: function(response, textStatus, errorThrown) {
      append_li(date_text + " " + errorThrown)
      var newDate = new Date(date.setDate(date.getDate() - 1));
      console.log(newDate);
      if(newDate > end_date){
        download(newDate,end_date,url)
      }
    },
    success: function (data) {
      append_li(date_text + " OK COMPLETE")
      var newDate = new Date(date.setDate(date.getDate() - 1));
      if(newDate > end_date){
        download(newDate,end_date,url)
      }

    }
  });
}


function append_li(text)
{ var li = $('<li />', {
    class: 'list-group-item',
  }).text(text);
  $('ul.add_here').find('li:first-child').before(li)
}